import SemeiaSessionService from "parog-web/services/session";

export function initialize(application) {
  application.register("service:session", SemeiaSessionService);
}

export default {
  initialize
};
